import { BulkSelectionControlPlayground } from "../BulkSelectionControlPlayground";
import { FilterActionsFooterPlayground } from "../FilterActionsFooterPlayground";
import { ViewToolbarPlayground } from "../ViewToolbarPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const filtersToolbarEntries: PlaygroundComponentEntry[] = [
    {
        id: "filter-actions-footer",
        label: "Filter actions footer",
        description: "Apply/clear footer for filter popovers.",
        group: "components",
        render: () => <FilterActionsFooterPlayground />,
    },
    {
        id: "view-toolbar",
        label: "View toolbar",
        description: "Table view toolbar with filter and sort slots.",
        group: "components",
        render: () => <ViewToolbarPlayground />,
    },
    {
        id: "bulk-selection-control",
        label: "Bulk selection control",
        description: "Select-all control with partial selection state.",
        group: "components",
        render: () => <BulkSelectionControlPlayground />,
    },
];
